<template>

  <div class="white-bg" style="padding: 10px; min-height: 100vh">

    <p class=MsoNormal align=center style='margin-bottom:0cm;margin-bottom:.0001pt;
    text-align:center;line-height:normal'><b><u><span
            lang=EN-US style='font-size:
    10.0pt;font-family:Arial'>NOTICE UNDER THE PERSONAL DATA PROTECTION ACT
            2010
          </span></u></b></p>

    <p class=MsoNormal align=center style='margin-bottom:0cm;margin-bottom:.0001pt;
    text-align:center;line-height:normal'><b><i><u><span
              lang=MS style='font-size:
    10.0pt;font-family:Arial'>NOTIS DI BAWAH AKTA PERLINDUNGAN DATA PERIBADI
              2010</span></u></i></b></p>

    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:
    justify;text-justify:inter-ideograph;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>&nbsp;</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:
    justify;text-justify:inter-ideograph;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>The Personal Data Protection Act
        2010 (the "<b>Act"</b>), which regulates the processing of personal data in
        commercial transactions, applies to PARKAIDE MOBILE (M) SDN BHD ("<b>our</b>",
        "<b>us</b>" or "<b>we</b>"). &nbsp;For the purpose of this written notice ("<b>Notice</b>"),
        the terms "<b>personal data</b>" and "<b>processing</b>" shall have the same meaning
        as prescribed in the Act.</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:
    justify;text-justify:inter-ideograph;line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>Akta Perlindungan Data Peribadi 2010
          ("<b>Akta</b>" tersebut) yang mengawal selia pemprosesan data peribadi dalam
          transaksi komersial, terpakai kepada </span></i><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>Parking
        Network System Sdn Bhd </span><i><span lang=MS style='font-size:10.0pt;font-family:Arial'>("<b>kami</b>").
          Untuk
          tujuan notis bertulis ini ("<b>Notis</b>"), terma-terma "<b>data peribadi</b>"
          dan "<b>pemprosesan</b>" mempunyai maksud yang sama seperti yang ditakrif dalam
          Akta tersebut.</span></i></p>

    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:
    justify;text-justify:inter-ideograph;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>&nbsp;</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:
    justify;text-justify:inter-ideograph;line-height:normal'><b><span
          lang=EN-US style='font-size:9.0pt;font-family:Arial'>Consent/ <i>Persetujuan </i></span></b></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>This Notice
        serves to inform you that your personal data is being processed by us or on our
        behalf when you access our website at https://www.parkaidemobile.com ("<b>Website</b>")
        and you hereby give your consent to the processing of your personal data.</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>Notis
          ini bertujuan untuk memaklumkan kepada anda bahawa data peribadi anda sedang
          diproses oleh atau bagi pihak kami apabila anda mengakses laman web kami di </span></i><span lang=EN-US style='font-size:10.0pt;font-family:Arial'><a
          href="https://www.parkaidemobile.com">https://www.parkaidemobile.com</a> </span><i><span lang=MS style='font-size:10.0pt;font-family:Arial'>(&quot;<b>Laman
            Web</b>&quot;)
          dan anda dengan ini memberikan persetujuan anda bagi pemprosesan data peribadi
          anda.</span></i></p>

    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:
    justify;text-justify:inter-ideograph;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>&nbsp;</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:
    justify;text-justify:inter-ideograph;line-height:normal'><b><span
          lang=EN-US style='font-size:9.0pt;font-family:Arial'>Description of personal data/<i> Perihalan
            data peribadi </i></span></b></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>2.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>We
        may collect a variety of your personal data including but not limited to your
        name, Malaysian Identification Card number, e-mail address, contact number, credit
        card details, bank account details, other personal data you submitted to us through
        the Website and all other personal data we again collect from you on any
        subsequent occasion.</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>Kami
          mungkin mengumpul pelbagai data peribadi anda termasuk tetapi tidak terhad
          kepada nama, nombor Kad Pengenalan Malaysia, alamat e-mel, nombor telefon, maklumat
          kad kredit, maklumat akaun bank, data peribadi lain yang anda hantar kepada
          kami melalui Laman Web dan semua data peribadi lain kami sekali lagi kumpul
          daripada anda pada bila-bila masa kemudiannya.</span></i></p>

    <p class=MsoListParagraph style='margin-left:0cm'><span lang=MS style='font-size:9.0pt;font-family:Arial'>&nbsp;</span></p>

    <p class=MsoListParagraph style='margin-left:0cm'><b><span lang=EN-US style='font-size:9.0pt;font-family:Arial'>Purpose
          / <i>Maksud</i></span></b></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>3.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>Your personal
        data is being or is to be collected and further processed for:</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>Data
          peribadi anda sedang atau akan dikumpulkan dan diproses selanjutnya untuk:</span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>&nbsp;</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>(a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>performing our
        pre-contractual and contractual obligation with you;</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>melaksanakan
          obligasi pra-kontrak dan kontrak dengan anda;</span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>(b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>granting you access to the
        services available on the Website;</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>memberikan
          anda akses perkhidmatan-perkhidmatan yang terdapat di dalam Laman Web</span></i><i><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>;</span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>(c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>providing
        you with the services and information offered through the Website;</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>memberikan
          anda perkhidmatan dan maklumat yang ditawarkan melalui Laman Web</span></i><i><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>;</span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>(d)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>verifying and carrying
        out financial transactions in relation to payments you make online;</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>mengesahkan
          dan melaksanakan transaksi kewangan berkenaan dengan bayaran online yang dibuat
          oleh anda</span></i><i><span lang=EN-US style='font-size:10.0pt;font-family:
    Arial'>;</span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>(e)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>providing our services to
        you (or your company, if applicable);</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>memberikan
          produk dan/atau perkhidmatan kami kepada anda (atau syarikat anda, jika
          berkenaan);</span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>(f)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>communicating
        with you;</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>berhubung
          dengan anda;</span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>(g)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>responding to your inquiries
        and resolving disputes;</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>menjawab
          pertanyaan anda dan menyelesaikan pertikaian; </span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>(h)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>conducting internal
        activities;</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>menjalankan
          kegiatan dalaman;</span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>(i)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>market
        surveys and trend analysis;</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>tinjauan
          pasaran dan analisis kecenderungan;</span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>(j)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>improving
        our services, content and advertising in the Website;</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>meningkatkan
          perkhidmatan, kandungan dan pengiklanan di dalam Laman </span></i><i><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>Web;</span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=MS style='font-size:10.0pt;
    font-family:Arial'>(k)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>providing
        you (or your company, if applicable) with information on our products and/or
        services, </span><span lang=MS style='font-size:10.0pt;font-family:Arial'>promotional
        offers and of our related corporations and business partners;</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>memberikan
          anda (atau syarikat anda, jika berkenaan) maklumat tentang produk dan/atau perkhidmatan
          kami, tawaran promosi dan perbadanan-perbadanan berkaitan kami dan rakan
          perniagaan kami;</span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>(l)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>conducting
        other legitimate business activities;</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>menjalankan
          kegiatan-kegiatan perniagaan sah lain;</span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>(m)<span style='font:7.0pt "Times New Roman"'>&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>complying with any legal or
        regulatory requirements; and</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>memenuhi
          apa-apa kehendak undang-undang atau kawal selia; dan</span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>(n)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>such other purposes
        directly related to the foregoing. </span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>maksud-maksud
          lain yang berhubungan secara langsung dengan yang tersebut di atas.</span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>&nbsp;</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>(collectively,
        the "<b>Purposes</b>").</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>(secara
          kolektif, "<b>Maksud-maksud</b>" tersebut).</span></i></p>

    <p class=MsoListParagraph style='margin-left:0cm'><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>&nbsp;</span></p>

    <p class=MsoListParagraph style='margin-left:0cm'><b><span lang=EN-US style='font-size:9.0pt;font-family:Arial'>Source
          of personal data/ <i>sumber
            data peribadi</i></span></b></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>4.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>Your
        personal data is being or is to be collected:</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>Data
          peribadi anda sedang atau akan dikumpulkan:</span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>&nbsp;</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>(a)&nbsp; from
        the cookies; </span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><i><span lang=MS
          style='font-size:10.0pt;font-family:Arial'>dari
          cookies;</span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>(b)&nbsp; from
        your Malaysian Identity Card;</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <i>dari
          Kad Pengenalan Malaysia anda; </i></span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>(c)&nbsp; when
        you register to have access to the Website, </span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><i><span lang=MS
          style='font-size:10.0pt;font-family:Arial'>apabila
          anda mendaftar bagi
          tujuan mengakses Laman Web kami;</span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>(d)&nbsp; when
        you log in to or use the Website; </span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><i><span lang=MS
          style='font-size:10.0pt;font-family:Arial'>apabila
          anda log masuk ke dalam
          atau menggunakan Laman Web;</span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>(e)&nbsp; when
        you contact our customer service centre; </span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:18.0pt;line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;
    font-family:Arial'>apabila anda menghubungi pusat perkhidmatan pelanggan
          kami;</span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>(f)&nbsp;&nbsp; when
        you submit your personal data to us for any of the Purposes;</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><i><span lang=MS
          style='font-size:10.0pt;font-family:Arial'>apabila
          anda menghantar data
          peribadi anda kepada kami untuk mana-mana Maksud;</span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>(g)&nbsp; from
        all other personal data we again collect from you on any subsequent occasion;
        and</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>dari
          data peribadi yang lain kami sekali lagi dapati daripada anda pada bila-bila
          masa kemudiannya; dan</span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>(i)&nbsp;&nbsp; from
        all other information that you may provide us from time to time.</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><i><span lang=MS
          style='font-size:10.0pt;font-family:Arial'>dari
          semua maklumat lain
          yang anda mungkin berikan kepada kami dari masa ke semasa.</span></i></p>

    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:
    justify;text-justify:inter-ideograph;line-height:normal'><span
        lang=MS style='font-size:10.0pt;font-family:Arial'>&nbsp;</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:
    justify;text-justify:inter-ideograph;line-height:normal'><b><span
          lang=EN-US style='font-size:9.0pt;font-family:Arial'>Access to, correction of and limiting
          the processing of personal data/ <i>Akses kepada, pembetulan terhadap dan had pemprosesan
            data peribadi</i> </span></b></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>5.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>You
        have the right to request access to and to request correction of your personal
        data and to contact us with any inquiries or complaints in respect of your
        personal data (including the possible </span><span lang=EN-US style='font-size:
    10.0pt;font-family:Arial'>choices
        and means for limiting the processing of your
        personal data or to cease or not begin processing your personal data for
        purposes of direct marketing)</span><span lang=EN-US style='font-size:10.0pt;
    font-family:Arial'> from:</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>Anda
          berhak untuk meminta akses kepada dan meminta pembetulan terhadap data peribadi
          anda dan untuk menghubungi kami tentang apa-apa pertanyaan atau aduan berkenaan
          dengan data peribadi anda (termasuk pilihan-pilihan dan cara-cara yang mungkin untuk
          mengehadkan pemprosesan data peribadi anda atau untuk memberhentikan atau tidak
          memulakan pemprosesan data peribadi anda bagi tujuan pemasaran langsung) daripada:</span></i></p>

    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    normal'><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>&nbsp;</span></p>

    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0 style='margin-left:23.4pt;border-collapse:collapse;border:none'>
      <tr style='height:14.3pt'>
        <td width=159 valign=top style='width:159.2pt;border:solid windowtext 1.0pt;
    padding:0cm 5.4pt 0cm 5.4pt;height:14.3pt'>
          <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    normal'><span lang=EN-US
              style='font-size:10.0pt;font-family:Arial'>Designation/</span><i><span lang=MS style='font-size:10.0pt;font-family:Arial'>
                Perjawatan</span></i><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>:</span></p>
        </td>
        <td width=291 valign=top style='width:290.6pt;border:solid windowtext 1.0pt;
    border-left:none;padding:0cm 5.4pt 0cm 5.4pt;height:14.3pt'>
          <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    normal'><i><span lang=MS
                style='font-size:10.0pt;font-family:Arial'>Customer
                Service</span></i></p>
        </td>
      </tr>
      <tr>
        <td width=159 valign=top style='width:159.2pt;border:solid windowtext 1.0pt;
    border-top:none;padding:0cm 5.4pt 0cm 5.4pt'>
          <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    normal'><span lang=EN-US
              style='font-size:10.0pt;font-family:Arial'>Telephone
              No./</span><i><span lang=MS style='font-size:10.0pt;font-family:Arial'> No.
                Telefon</span></i><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>:</span></p>
        </td>
        <td width=291 valign=top style='width:290.6pt;border-top:none;border-left:
    none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
    padding:0cm 5.4pt 0cm 5.4pt'>
          <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    normal'><span lang=EN-US
              style='font-size:10.0pt;font-family:Arial'>60378596198</span></p>
        </td>
      </tr>
      <tr>
        <td width=159 valign=top style='width:159.2pt;border:solid windowtext 1.0pt;
    border-top:none;padding:0cm 5.4pt 0cm 5.4pt'>
          <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    normal'><span lang=EN-US
              style='font-size:10.0pt;font-family:Arial'>Fax
              No./</span><i><span lang=MS style='font-size:10.0pt;font-family:Arial'> No. Fax</span></i><span lang=EN-US
              style='font-size:10.0pt;font-family:Arial'>:</span></p>
        </td>
        <td width=291 valign=top style='width:290.6pt;border-top:none;border-left:
    none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
    padding:0cm 5.4pt 0cm 5.4pt'>
          <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    normal'><span lang=EN-US
              style='font-size:10.0pt;font-family:Arial'>60378599198</span></p>
        </td>
      </tr>
      <tr>
        <td width=159 valign=top style='width:159.2pt;border:solid windowtext 1.0pt;
    border-top:none;padding:0cm 5.4pt 0cm 5.4pt'>
          <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    normal'><span lang=EN-US
              style='font-size:10.0pt;font-family:Arial'>E-mail
              address</span><i><span lang=MS style='font-size:10.0pt;font-family:Arial'>/ Alamat
                E-mel:</span></i></p>
        </td>
        <td width=291 valign=top style='width:290.6pt;border-top:none;border-left:
    none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
    padding:0cm 5.4pt 0cm 5.4pt'>
          <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    normal'><span lang=EN-US
              style='font-size:10.0pt;font-family:Arial'>service@parkaidemobile.com</span></p>
        </td>
      </tr>
    </table>

    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:
    justify;text-justify:inter-ideograph;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial;color:blue'>&nbsp;</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>6.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>Subject
        to provisions of the Act:</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>Tertakluk
          kepada peruntukan-peruntukan Akta tersebut:</span></i></p>

    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    normal'><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>&nbsp;</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>(a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>you may, upon payment of
        a prescribed fee, make a data access request in writing to us; and</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>Anda
          boleh, apabila dibayar fi yang ditetapkan, membuat suatu permintaan mengakses
          data secara bertulis kepada kami; dan</span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>(b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>we may refuse to comply
        with a data access request or a data correction request and shall, by notice in
        writing, inform you of our refusal and the reasons of our refusal. </span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:36.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>Kami
          boleh enggan mematuhi permintaan mengakses data atau permintaan pembetulan data
          dan hendaklah, melalui notis bertulis, memaklumkan anda mengenai keengganan
          tersebut dan sebab-sebab bagi keengganan tersebut.</span></i></p>

    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:
    justify;text-justify:inter-ideograph;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>&nbsp;</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:
    justify;text-justify:inter-ideograph;line-height:normal'><b><span
          lang=EN-US style='font-size:9.0pt;font-family:Arial'>Disclosure of personal data/ <i>Penzahiran
            data peribadi</i></span></b></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>7.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>We
        disclose or may disclose your personal data to our related corporations,
        business partners, service providers including but not limited to those
        directly related to the delivery of the products and/or services which are
        available on the Website, our financial and professional advisors, banks, governmental
        departments and/or agencies, regulatory and/or statutory bodies and any such
        third party requested or authorized by you for any of the Purposes.</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>Kami
          menzahirkan atau boleh menzahirkan data peribadi anda kepada perbadanan
          berkaitan kami, rakan-rakan perniagaan kami, pembekal-pembekal perkhidmatan kami
          termasuk tetapi tidak terhad kepada pembekal perkhidmatan yang berkaitan secara
          langsung kepada penghantaran produk dan/atau perkhidmatan yang sedia ada di
          dalam Laman Web, penasihat kewangan atau profesional kami, bank, jabatan-jabatan
          dan agensi-agensi kerajaan, badan-badan kawal selia dan/atau berkanun dan dan
          mana-mana pihak ketiga yang diminta atau dibenarkan oleh anda untuk mana-mana Maksud-maksud
          tersebut.</span></i></p>

    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:
    justify;text-justify:inter-ideograph;line-height:normal'><b><span
          lang=EN-US style='font-size:10.0pt;font-family:Arial'>&nbsp;</span></b></p>

    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:
    justify;text-justify:inter-ideograph;line-height:normal'><b><span
          lang=EN-US style='font-size:9.0pt;font-family:Arial'>Third party personal data/ <i>data
            peribadi pihak ketiga</i></span></b></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>8.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>We
        may require your assistance if the personal data relating to other persons is
        required to process your personal data for the Purposes and you hereby agree to
        use your best endeavors to assist us when required. In the event that personal data
        of any third party is supplied by you to us, you shall ensure that such third
        party has read this Notice and consented to us collecting his/her personal data
        for any of the Purposes prior to the supply of his/her personal data to us.</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>Kami
          boleh menghendaki bantuan anda jika data peribadi yang berhubungan dengan orang
          lain dikehendaki untuk memproses data peribadi anda untuk Maksud-maksud tersebut
          dan anda dengan ini bersetuju untuk menggunakan usaha terbaik anda untuk
          membantu kami bila dikehendaki. Jika data peribadi pihak ketiga telah diberikan
          oleh anda kepada kami, anda hendaklah memastikan bahawa pihak ketiga tersebut
          telah membaca Notis ini dan </span></i><i><span lang=MS style='font-size:10.0pt;
    font-family:Arial'>bersetuju
          dengan pemprosesan data peribanya</span></i><i><span lang=MS style='font-size:10.0pt;font-family:Arial'>
          untuk
          mana-mana Maksud
          sebelum memberikan data peribadinya kepada kami.</span></i></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><span
        lang=MS style='font-size:10.0pt;font-family:Arial'>&nbsp;</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:
    justify;text-justify:inter-ideograph;line-height:normal'><b><span
          lang=EN-US style='font-size:9.0pt;font-family:Arial'>Obligatory personal data/ <i>Data
            peribadi wajib</i></span></b></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>9.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>It is
        obligatory that you supply us the details marked with asterisk (*) in our registration
        form (collectively, "compulsory personal data").&nbsp; If you fail to supply us
        the compulsory personal data, we may refuse to process your personal data for
        any of the Purposes and/or result in us being unable to provide you with the
        services and/or products requested.</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>Ia
          adalah wajib untuk anda memberikan kepada kami butir-butir bertanda asterisk
          (*) dalam borang pendaftaran online kami (secara kolektif, "data peribadi
          wajib").&nbsp; Jika anda gagal untuk memberikan kami data peribadi wajib
          tersebut, kami boleh enggan untuk memproses data peribadi anda untuk mana-mana Maksud-maksud
          tersebut dan/atau menyebabkan kami tidak dapat memberikan anda produk dan/atau
          perkhidmatan yang diminta. </span></i></p>

    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:
    justify;text-justify:inter-ideograph;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;font-family:Arial'>&nbsp;</span></p>

    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:
    justify;text-justify:inter-ideograph;line-height:normal'><b><span
          lang=EN-US style='font-size:9.0pt;font-family:Arial'>Transfer of personal data to places
          outside Malaysia/ <i>Pemindahan data peribadi ke tempat di luar Malaysia</i></span></b></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>10.<span style='font:7.0pt "Times New Roman"'>&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>We may transfer your
        personal data to a place outside Malaysia and you hereby give your consent to
        the transfer.</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>Kami
          boleh memindahkan data peribadi anda ke sesuatu tempat di luar Malaysia dan
          anda dengan ini memberikan persetujuan anda tehadap pemindahan tersebut.</span></i></p>

    <p class=MsoListParagraph style='margin-left:0cm;text-align:justify;text-justify:
    inter-ideograph'><span lang=EN-US
        style='font-size:10.0pt;font-family:Arial'>&nbsp;</span></p>

    <p class=MsoListParagraph style='margin-left:0cm;text-align:justify;text-justify:
    inter-ideograph'><b><span
          lang=EN-US style='font-size:9.0pt;font-family:Arial'>Accuracy
          of your personal data/ <i>Ketepatan data peribadi</i></span></b></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>11.<span style='font:7.0pt "Times New Roman"'>&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial'>You are responsible for ensuring
        that the information you provide us is accurate, complete, not misleading and kept
        up to date.</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>Anda
          bertanggungjawab untuk memastikan bahawa maklumat yang anda berikan kami adalah
          tepat, lengkap, tidak mengelirukan dan terkini.</span></i></p>

    <p class=MsoListParagraph style='margin-left:0cm;text-align:justify;text-justify:
    inter-ideograph'><span lang=EN-US
        style='font-size:10.0pt;font-family:Arial'>&nbsp;</span></p>

    <p class=MsoListParagraph style='margin-left:0cm;text-align:justify;text-justify:
    inter-ideograph'><b><span
          lang=EN-US style='font-size:9.0pt;font-family:Arial'>Conflict/
          K<i>onflik</i></span></b></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    text-indent:-18.0pt;line-height:normal'><span
        lang=EN-US style='font-size:10.0pt;
    font-family:Arial'>12.<span style='font:7.0pt "Times New Roman"'>&nbsp;
        </span></span><span lang=EN-US style='font-size:10.0pt;font-family:Arial;color:black;background:
    transparent'>In
        the event of any
        inconsistency between the English version and
        the Bahasa Malaysia version of this Notice, the English version shall prevail
        over the Bahasa Malaysia version.</span></p>

    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph;
    line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>Sekiranya
          terdapat apa-apa ketidak-konsistenan antara versi Bahasa Inggeris dan versi
          Bahasa Malaysia Notis ini, versi Bahasa Inggeris akan mengatasi versi Bahasa
          Malaysia.</span></i></p>

    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:
    justify;text-justify:inter-ideograph;line-height:normal'><i><span
          lang=MS style='font-size:10.0pt;font-family:Arial'>&nbsp;</span></i></p>

  </div>

</template>

<script>
import helper from "@/components/Utility/Helper"

export default {
  name: "PagePrivacyPolicy",
  data(){
      return {
      }
  },
  mounted() {
    if(window.location.href.includes('localhost')) {
      document.title = 'Localhost';
    } else if(window.location.href.includes('parkbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    } else if(window.location.href.includes('devpbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    }
  },
  methods : {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/User/PagePrivacyPolicy.vue